import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { fetchBrands, createBrand, updateBrand, deleteBrand } from "../../../slices/company/brandSlice";
import BrandsForm from "./brands_form";
import DataTable from 'react-data-table-component';
import { customTableStyles } from "../../../utils/tableStylings";
import { Delete, Pen } from "lucide-react";
import { Link } from "react-router-dom";

const Brands = () => {
  const dispatch = useDispatch();
  const { brands, loading, error } = useSelector((state) => state.brands);
  const [showModal, setShowModal] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [modalHeading, setModalHeading] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const company = JSON.parse(localStorage.getItem("company"));
    if (company) {
      const companyId = company.company?.id;
      dispatch(fetchBrands(companyId));
    }
  }, [dispatch]);

  const handleAdd = () => {
    setSelectedBrand(null);
    setModalHeading("Create New Brand");
    setShowModal(true);
  };

  const handleEdit = (brand) => {
    setSelectedBrand(brand);
    setModalHeading("Edit Brand");
    setShowModal(true);
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "<strong>Are you sure?</strong>",
      html: `<p>This action will <b>permanently delete</b> this Brand.</p>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteBrand(id));
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The Brand has been deleted.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      }
    });
  };

  const handleFormSubmit = (formData) => {
    if (selectedBrand && selectedBrand.id != null) {
      dispatch(updateBrand({ id: selectedBrand.id, brandData: formData }));
    } else {
      dispatch(createBrand(formData));
    }
    setShowModal(false);
  };

  // DataTable columns
  const columns = [
    {
      name: '#',
      selector: (row, index) => index + 1,
      width: '50px',
      sortable: false,
    },
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Slug',
      selector: row => row.slug,
      sortable: true,
    },
    {
      name: 'Description',
      selector: row => row.description || 'N/A',
      sortable: false,
    },
    {
      name: 'Actions',
      cell: row => (
        <>
          <Link
            className="text-warning me-2"
            onClick={() => handleEdit(row)}
          >
            <Pen />
          </Link>
          <Link
            className="text-danger"
            onClick={() => handleDelete(row.id)}
          >
            <Delete />
          </Link>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '150px',
    },
  ];

  // Filter brands by search
  const filteredBrands = brands.filter(
    (brand) =>
      brand.name.toLowerCase().includes(search.toLowerCase()) ||
      brand.slug.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>

      <div className="card">

         <div className="card-header d-flex justify-content-between align-items-center gap-2">
            <h3 className="text-primary mb-0">Brands</h3>
            <span className="d-flex align-items-center gap-2">
                <input
                    type="text"
                    placeholder="Search Brands"
                    className="form-control"
                    value={search}
                    style={{ width: "220px" }}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <button type="button" onClick={handleAdd} className="btn btn-primary">Add New</button>
            </span>
        </div>
        <div className="card-body">

          {loading && <div>Loading...</div>}
          {error && <div className="text-danger">{error}</div>}
          <DataTable
            className="table-hover custom-table"
            columns={columns}
            data={filteredBrands}
            pagination
            striped
            customStyles={customTableStyles}
            progressPending={loading}
            noDataComponent={<div className="text-center">No brands found.</div>}
          />
        </div>
      </div>
      {showModal && (
        <BrandsForm
          show={showModal}
          onClose={() => setShowModal(false)}
          heading={modalHeading}
          initialData={selectedBrand}
          onSubmit={handleFormSubmit}
        />
      )}
    </>
  );
};

export default Brands;
